import {
  FETCH_CART_ITEMS,
  FETCH_CART_ITEMS_SUCCESS,
  FETCH_CART_ITEMS_ERROR,
  UPDATE_CART_ITEM,
  UPDATE_CART_ITEM_SUCCESS,
  UPDATE_CART_ITEM_ERROR,
  REMOVE_CART_ITEM,
  REMOVE_CART_ITEM_SUCCESS,
  REMOVE_CART_ITEM_ERROR,
  FETCH_CART_COUNT,
  FETCH_CART_COUNT_SUCCESS,
  FETCH_CART_COUNT_ERROR,
  MOVE_TO_WISHLIST,
  MOVE_TO_WISHLIST_SUCCESS,
  MOVE_TO_WISHLIST_ERROR,
} from '../actionTypes';

const INIT_STATE = {
  items: [],
  summary: null,
  error: '',
  loading: false,
  updatedItem: null,
  deletedItem: null,
  updating: '',
  cartCount: 0,
  countLoading: false,
  otherProperties: null,
};

const reducer = (state = INIT_STATE, action) => {
  switch (action.type) {
    case FETCH_CART_ITEMS:
      return { ...state, loading: true, error: '' };
    case FETCH_CART_ITEMS_SUCCESS: {
      const { cartDetails, allTotal, ...restProps } = action.payload; // utilise totalProductType later

      return {
        ...state,
        loading: false,
        items: [...cartDetails],
        summary: { ...allTotal },
        otherProperties: { ...restProps },
        error: '',
      };
    }
    case FETCH_CART_ITEMS_ERROR:
      return {
        ...state,
        loading: false,
        error: action.payload.message,
      };
    case UPDATE_CART_ITEM:
      return {
        ...state,
        updating: action.payload.product,
        error: '',
        updatedItem: null,
      };
    case UPDATE_CART_ITEM_SUCCESS: {
      return {
        ...state,
        updating: '',
        updatedItem: action.payload,
        error: '',
      };
    }
    case UPDATE_CART_ITEM_ERROR:
      return {
        ...state,
        updating: '',
        error: action.payload.message,
      };
    case REMOVE_CART_ITEM:
      return {
        ...state,
        updating: action.payload.product,
        error: '',
        deletedItem: null,
      };
    case REMOVE_CART_ITEM_SUCCESS: {
      return {
        ...state,
        updating: '',
        deletedItem: action.payload,
        error: '',
      };
    }
    case REMOVE_CART_ITEM_ERROR:
      return {
        ...state,
        updating: '',
        error: action.payload.message,
      };
    case FETCH_CART_COUNT:
      return {
        ...state,
        countLoading: true,
        error: '',
      };
    case FETCH_CART_COUNT_SUCCESS: {
      return {
        ...state,
        countLoading: false,
        cartCount: action.payload,
        error: '',
      };
    }
    case FETCH_CART_COUNT_ERROR:
      return {
        ...state,
        countLoading: false,
        error: action.payload.message,
      };
    case MOVE_TO_WISHLIST:
      return {
        ...state,
        updating: true,
        updatedItem: null,
        error: '',
      };
    case MOVE_TO_WISHLIST_SUCCESS: {
      return {
        ...state,
        updating: false,
        updatedItem: action.payload,
        error: '',
      };
    }
    case MOVE_TO_WISHLIST_ERROR:
      return {
        ...state,
        updating: false,
        error: action.payload.message,
      };
    default:
      return { ...state };
  }
};

export default reducer;
